import React from 'react';
import PropTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';
import { colors, TextField } from '@mui/material';

export default function InputField(props) {
  const {
    name,
    upperCase,
    disabled,
    showErrorOnChange,
    showErrorOnChangeMessages,
    showErrorOnSubmitOnly = false,
    required,
    requiredHintText = 'This field is required',
    sx,
    ...rest
  } = props;
  const [field, meta] = useField(name);
  const { value: selectedValue } = field;
  const { setFieldValue, submitCount } = useFormikContext();

  const isLiveErrorMessageAllowed = Boolean(
    showErrorOnChange
    && meta.error
    && (
      !Array.isArray(showErrorOnChangeMessages)
      || showErrorOnChangeMessages.includes(meta.error)
    )
  );

  const shouldShowError = Boolean(
    meta.error
    && (showErrorOnSubmitOnly ? submitCount > 0 : meta.touched || isLiveErrorMessageAllowed)
  );

  const isValueEmpty = (value) => {
    if (Array.isArray(value)) {
      return value.length === 0;
    }
    if (value == null) {
      return true;
    }
    if (typeof value === 'string') {
      return value.trim() === '';
    }
    return false;
  };

  function renderHelperText() {
    if (shouldShowError) {
      return meta.error;
    }
    if (required && isValueEmpty(selectedValue)) {
      return requiredHintText;
    }
    return null;
  }

  const handleInputChange = (e) => {
    let value = e.target.value || '';
    if (upperCase) {
      value = value.toUpperCase();
    }
    setFieldValue(name, value);
  };

  return (
    <TextField
      type="text"
      {...field}
      {...rest}
      disabled={disabled}
      sx={[
        { backgroundColor: disabled ? colors.grey[200] : 'inherit' },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      value={selectedValue == null ? '' : selectedValue}
      error={shouldShowError}
      helperText={renderHelperText()}
      onChange={handleInputChange}
    />
  );
}

InputField.propTypes = {
  name: PropTypes.string,
  upperCase: PropTypes.bool,
  disabled: PropTypes.bool,
  showErrorOnChange: PropTypes.bool,
  showErrorOnChangeMessages: PropTypes.arrayOf(PropTypes.string),
  showErrorOnSubmitOnly: PropTypes.bool,
  required: PropTypes.bool,
  requiredHintText: PropTypes.string,
  sx: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.func,
    PropTypes.object
  ])
};
